export const styleOverrides = {
  root: ({ theme }) => ({
    marginTop: 8,
    marginBottom: 8,
    border: "1px solid " + theme.palette.border.main,
    borderRadius: 4,
    "&:before": { display: "none" },
    backgroundColor: theme.palette.background.default,
  }),
};
